import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import smartParse from 'vue-smart-parse';
import echarts from 'echarts';

import ElementUI from 'element-ui';
// import imgFallback from './utils/img-fallback';

Vue.config.productionTip = false
// 基础样式
import "./assets/css/base.css";
import "swiper/css/swiper.min.css";
import "./assets/font/iconfont.css";
import "./assets/font/iconfont";
import axios from "axios";
import moment from "moment";
import md5 from 'js-md5';

// Vue.prototype.baseurl = "http://localhost:81"; // 本地测试环境
// Vue.prototype.baseurl = "http://192.168.31.5:81";
// Vue.prototype.baseurl = "http://39.105.200.246";
// Vue.prototype.baseurl = "http://www.jmtbook.cn"; // 此链接不能接入websocket
// Vue.prototype.baseurl = "http://admin.jmtbook.cn:82";// 正式环境

// Vue.prototype.baseurl = "http://www.jmtbook.cn:81";
Vue.prototype.baseurl = process.env.VUE_APP_API_BASE_URL;

Vue.prototype.projectName = "/bookshop";
Vue.prototype.staticDomainURL = Vue.prototype.baseurl+Vue.prototype.projectName + "/sys/common/static"; // 静态文件地址
Vue.prototype.frontDomianURL = Vue.prototype.baseurl+Vue.prototype.projectName + "/front";
Vue.prototype.domianURL = Vue.prototype.baseurl + Vue.prototype.projectName;

const noImgUrl = require('@/assets/img/noImg.png');
// 保存原始组件
const OriginalImage = ElementUI.Image
// 创建增强版组件
const EnhancedElImage = {
  extends: OriginalImage,
  methods: {
    // 错误图片检测
    isErrorImage(img) {
      return (
        /nofound_o\.jpg/.test(img)
      )
    },
    // 检查图片状态
    async checkImageStatus() {
      try {
        // 为null时
        if (!this.src) {
          this.src = noImgUrl
          // 睡眠100ms
          await new Promise(resolve => setTimeout(resolve, 100))
        } else if (/ddimg\.cn/.test(this.src)) {
            let response = await fetch(this.src);
            if (this.isErrorImage(response.url)) {
              this.src = noImgUrl
            }
        }
      } catch (error) {
        // console.log("error", error);
      }
      OriginalImage.methods.loadImage.call(this)
    }
  },
  mounted() {
    this.checkImageStatus()
  }
}
// 全局注册增强组件
Vue.component('el-image', EnhancedElImage)

Vue.prototype.$axios = axios;
Vue.prototype.$md5 = md5;
Vue.prototype.$moment = moment;

Vue.use(ElementUI);
Vue.use(smartParse);
Vue.use(echarts);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.filter("dateFormat",function(value,format){
  return moment(value).format(format || "YYYY-MM-DD HH:mm:ss");
})

